
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-contacts-plus{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-6);
}

  .se-contacts-plus__link{
    padding:var(--spacing-4) 0;
  }

  .se-contacts-plus__teasers ::slotted(div[slot='contact-teasers-plus']){
    display:flex;
    flex-direction:column;
    gap:var(--spacing-4);
  }
`;